// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowseBy_wrapper__e8apr","cardsWrapper":"BrowseBy_cardsWrapper__DyktQ","card":"BrowseBy_card__sVlkh"};